<template>
  <HKLModal
    ref="modal"
    okBtnAction="onHold"
    @onCloseClick="cleanModalState"
  >
    <div
      slot="title"
      v-html="$t('tenantProjects.greenFitOut.onHoldAlert')"
    />
    <HKLForm
      ref="form"
      class="check-validation"
    >
      <div class="text-input">
        <textarea
          v-model="onHoldComment"
          v-autosize
          v-hkldinput
          v-fusioninputcheck="{
            type: 'string',
            required: true
          }"
        />
      </div>
    </HKLForm>
  </HKLModal>
</template>

<script>
import HKLForm from '@/controls/Form/HKLForm'
import HKLInput from '@/controls/Input/HKLInput'
import HKLModal from '@/controls/Modal/HKLModal'
import { unref, ref, onMounted } from 'vue-demi'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { useCurrentGreenFitout, useRefreshCurrentGreenFitout } from './hook'
import { onHoldGreenFitoutSubmission } from '@/api/tenantProjects/greenFitout.request'
import { utils as formUtils } from '@/plugin/InputChange'
import { useRefForm } from '@/controls/Form/hook'

export default {
  components: {
    HKLInput,
    HKLForm,
    HKLModal,
  },
  setup () {
    const forms = useRefForm()
    const modals = useRefModal()
    const submission = useCurrentGreenFitout()
    const onHoldComment = ref('')
    const refresh = useRefreshCurrentGreenFitout()
    const onHold = async () => {
      if (!forms.validate()) return
      await onHoldGreenFitoutSubmission(unref(submission).id, { onHold: true, comment: onHoldComment.value })
      await refresh()
      cleanModalState()
      modals.close()
    }
    const cleanModalState = () => {
      onHoldComment.value = ''
      formUtils.resetDirty()
    }

    onMounted(() => {
      modals.modal.value.onClick = async () => {
        await onHold()
      }
    })

    return {
      ...modals,
      ...forms,
      onHoldComment,
      onHold,
      cleanModalState,
    }
  },
}
</script>
<style lang="scss" scoped>
@import '~styles/textField';
</style>
